import React, { useEffect, useState } from "react";
import "../../../styles/inventory.css";
import { Link } from "react-router-dom";
import VerifiedNavigation from "../../navigation/components/VerifiedNavigation";
import { InventoryServices } from "../services/InventoryServices";
import { FaPlus, FaSearch } from "react-icons/fa";
import { IoClose, IoFilter } from "react-icons/io5";
import Items from "../components/Items";
import InventoryOption from "../components/InventoryOption";
import Collections from "./Collections";

const Inventory = () => {
  const [inventory, setInventory] = useState([]);
  const [filteredInventory, setFilteredInventory] = useState([]);
  const [option, setOption] = useState("products");
  const [updateState, setUpdateState] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedFilter, setSelectedFilter] = useState(null);

  const fetchInventory = async () => {
    const response = await InventoryServices.fetchInventory();
    setInventory(response.data.inventory);
    setFilteredInventory(response.data.inventory);
  };

  const handleFilters = () => setShowFilters((prev) => !prev);

  const handleFilterOption = (option) => {
    setSelectedFilter(option); // highlight selected
    let sorted = [...inventory]; // base off original inventory each time

    switch (option) {
      case "A-Z":
        sorted.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "Z-A":
        sorted.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "Low-High":
        sorted.sort((a, b) => a.price - b.price);
        break;
      case "High-Low":
        sorted.sort((a, b) => b.price - a.price);
        break;
      case "Available":
        sorted = sorted.filter((item) => item.stockStatus === "available");
        break;
      case "Unavailable":
        sorted = sorted.filter((item) => item.stockStatus === "unavailable");
        break;
      default:
        sorted = [...inventory];
    }

    setFilteredInventory(sorted);
  };

  const handleResetFilters = () => {
    setFilteredInventory(inventory);
    setSelectedFilter(null);
  };

  useEffect(() => {
    const results = inventory.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredInventory(results);
  }, [search, inventory]);

  useEffect(() => {
    fetchInventory();
  }, [updateState]);

  return (
    <div className="inventory">
      <VerifiedNavigation />
      <InventoryOption inventory={inventory} setOption={setOption} />

      <div className="inventory-container">
        <div className="inventory-header">
          <h1>Inventory</h1>
          <Link to="/manager/inventory/add-new-product">
            <FaPlus /> Add Product
          </Link>
        </div>

        <div className="product-headers">
          <div className="product-header-left">
            <p onClick={handleFilters}>
              {showFilters ? <IoClose /> : <IoFilter size={17} />}
              Filters
            </p>
            {showFilters && (
              <ul>
                {[
                  "A-Z",
                  "Z-A",
                  "High-Low",
                  "Low-High",
                  "Available",
                  "Unavailable",
                ].map((filter) => (
                  <li
                    key={filter}
                    onClick={() => handleFilterOption(filter)}
                    className={selectedFilter === filter ? "active-filter" : ""}
                  >
                    {filter}
                  </li>
                ))}
                {selectedFilter && (
                  <button
                    onClick={handleResetFilters}
                    className="reset-filter-btn"
                  >
                    Reset Filters
                  </button>
                )}
              </ul>
            )}
          </div>

          <div className="product-header-right">
            <FaSearch size={17} color="grey" />
            <input
              placeholder="Search"
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {option === "products" && (
          <Items
            updateState={updateState}
            setUpdateState={setUpdateState}
            inventory={filteredInventory}
          />
        )}

        {option === "collections" && (
          <Collections inventory={filteredInventory} />
        )}
      </div>
    </div>
  );
};

export default Inventory;
